import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../../src/environments/environment';
import { AuthService } from '../authentication/auth.service';
import { Injector } from '@angular/core';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	constructor(private injector:Injector) {}

	private authService: AuthService;
	private oauthService: OAuthService;

	intercept(request: HttpRequest<object>, next: HttpHandler): Observable<HttpEvent<object>> {
		let clone: HttpRequest<object> = request.clone();
		if (request.url.startsWith(environment.apiURL)) {
			if (this.getOauthService().hasValidAccessToken()) {
				const headers = new HttpHeaders({ Authorization: `Bearer ${this.getOauthService().getAccessToken()}` });
				clone = request.clone({ headers: headers });
			} else {
				this.getAuthService().logout();
			}
		}
		return next.handle(clone);
	}

	getAuthService(): AuthService {
		if (typeof this.authService === 'undefined') {
		  this.authService = this.injector.get(AuthService);
		}
		return this.authService;
	}
	getOauthService(): OAuthService {
		if (typeof this.oauthService === 'undefined') {
		  this.oauthService = this.injector.get(OAuthService);
		}
		return this.oauthService;
	}
}
